import { render } from "./LoadedComponent.vue?vue&type=template&id=6b725ce8"
import script from "./LoadedComponent.vue?vue&type=script&lang=js"
export * from "./LoadedComponent.vue?vue&type=script&lang=js"

import "./LoadedComponent.vue?vue&type=style&index=0&id=6b725ce8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__